/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesMatchSchema } from "./matchSchema.ts";
import { goodLuckCoreEntitiesRosterInvitationSchema } from "./rosterInvitationSchema.ts";
import { goodLuckCoreEntitiesRosterMemberSchema } from "./rosterMemberSchema.ts";
import { goodLuckCoreEntitiesRosterOriginSchema } from "./rosterOriginSchema.ts";
import { goodLuckCoreEntitiesTournamentRegistrationSchema } from "./tournamentRegistrationSchema.ts";
import { goodLuckCoreEntitiesTournamentSchema } from "./tournamentSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesRosterSchema = z.object({
  id: z.string().nullish(),
  name: z.string().min(1),
  tag: z.string().min(2).max(3),
  slug: z.string().max(200).nullish(),
  icon: z.string().nullish(),
  banner: z.string().nullish(),
  description: z.string().nullish(),
  logoUrl: z.string().nullish(),
  captainId: z.string().nullish(),
  maxMembers: z.optional(z.int()),
  invitationToken: z.string().nullish(),
  tournamentId: z.string().nullish(),
  isTemporary: z.optional(z.boolean()),
  get origin() {
    return goodLuckCoreEntitiesRosterOriginSchema.optional();
  },
  lobbyNumber: z.int().nullish(),
  isLookingForPartner: z.optional(z.boolean()),
  acceptScrimInvites: z.optional(z.boolean()),
  isVerified: z.optional(z.boolean()),
  verifiedAt: z.iso.datetime().nullish(),
  verificationReason: z.string().max(500).nullish(),
  verificationUpdatedAt: z.iso.datetime().nullish(),
  verificationUpdatedByUserId: z.string().max(255).nullish(),
  archivedAt: z.iso.datetime().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  get captain() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  get tournament() {
    return goodLuckCoreEntitiesTournamentSchema.optional();
  },
  get members() {
    return z.array(goodLuckCoreEntitiesRosterMemberSchema).nullish();
  },
  get invitations() {
    return z.array(goodLuckCoreEntitiesRosterInvitationSchema).nullish();
  },
  get tournamentRegistrations() {
    return z.array(goodLuckCoreEntitiesTournamentRegistrationSchema).nullish();
  },
  get team1Matches() {
    return z.array(goodLuckCoreEntitiesMatchSchema).nullish();
  },
  get team2Matches() {
    return z.array(goodLuckCoreEntitiesMatchSchema).nullish();
  },
  get wonMatches() {
    return z.array(goodLuckCoreEntitiesMatchSchema).nullish();
  },
});
